



























































import { Component, Prop} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import BillingMixin from '@/mixins/billing-mixin';

@Component({})
export default class ManageAddonEstimate extends mixins(PlanLimitsMixin, BillingMixin) {
  @Prop({ default: {} })
  estimate: Estimate;

  @Prop({ default: {} })
  data: {
    planLimit: null | keyof BillingLimits
  };

  @Prop()
  finalAmount: number | null;

  @Prop({ default: 0 })
  pricePerMonth: number
  
  get billing(){
    return this.$store.state.billing
  }
  
  get invoiceEstimate(){
    return this.estimate.invoice_estimate || this.estimate.next_invoice_estimate
  }
  
  get creditNoteEstimates(){
    return this.estimate.credit_note_estimates?.[0]?.total
  }
  
  get prevPurchasedAddons(){
    const addonsArray = Object.values(this.billing.addons) as PlanAddon[]
    return addonsArray.filter(item=>item.addonName!==this.data.planLimit)
  }
  
  get totalShouldBePaidOn(){ 
    const allOldAddonsPrice = this.prevPurchasedAddons.reduce((acc,addon)=>{
      acc = +addon.addonTotalPrice + acc;
      return acc
    },0)
    const oldPrice = this.billing.planPrice + allOldAddonsPrice
    return this.estimate?.estimateType==='delete' ? oldPrice : oldPrice + this.pricePerMonth
  }
  
  get creditApplied(){
    const discountsAmount = this.invoiceEstimate.discounts?.reduce((acc,item)=>acc+item.amount,0) || 0
    return this.invoiceEstimate.credits_applied + discountsAmount
  }
}
